import {addClass, getCookie, makeElement, removeClass, setCookie} from '../../common/Utils';
import { ncBannerOptions } from '../../interface/ICommonbanner';
import { replaceLocale, setStartEndDateTime } from '../utils/Utils';

/**
 * @category Commonbanner
 * @description
 * 토스트 배너
 * 메인페이지에서만 노출
 * 닫기 클릭 -> 브라우저 쿠키가 삭제 되기 전까지 팝업 안됨
 */

class MainToastLayer {
    isCookieApply: boolean;
    bannerEl!: HTMLElement;
    el!: HTMLElement;

    constructor(_isMain: boolean = false, _isLauncher:boolean = false, _data:ncBannerOptions, useCookie: boolean) {
        this.isCookieApply = useCookie;

        let thisIsCookieApply = this.isCookieApply && getCookie(_data.mainToastBanner.Cookie);

        if( !_isMain || !_data.mainToastBanner.show || thisIsCookieApply || _data.mainFloatingBanner.show){
            return;
        }

        if ( _isLauncher && !_data.mainToastBanner.LauncherShow ) {
            return;
        }

        setStartEndDateTime(_data, _data.mainToastBanner, this.templateMainToast.bind(this));
    }

    templateMainToast(_data: ncBannerOptions){
        this.bannerEl = this.template( _data ) ;

        document.body.appendChild( this.bannerEl );
        this.addEvents(_data);

        setTimeout(()=> {
            addClass( this.bannerEl , 'is-show');
        }, 1000);
    }

    template(_data: ncBannerOptions){
        this.el = makeElement( `

            <div class="nc-banner" data-type="toast">
             ${_data.mainToastBanner.Link != ''?`
                 <a href="${replaceLocale(_data.mainToastBanner.Link!)}" ${_data.mainToastBanner.LinkNewWindow ? 'target=_blank' :''} class="nc-banner-link" style="background-image:url('${_data.mainToastBanner.BG}')">
                    <div class="nc-banner-inner">
                        <div class="nc-banner-tag">${_data.mainToastBanner.Lable}</div>
                        <strong class="nc-banner-title-main">${_data.mainToastBanner.Title}</strong>
                        <em class="nc-banner-title-sub">${_data.mainToastBanner.SubTitle}</em>
                    </div>
                </a>
            ` : `
               <span class="nc-banner-link" style="background-image:url('${_data.mainToastBanner.BG}')">
                    <div class="nc-banner-inner">
                        <div class="nc-banner-tag">${_data.mainToastBanner.Lable}</div>
                        <strong class="nc-banner-title-main">${_data.mainToastBanner.Title}</strong>
                        <em class="nc-banner-title-sub">${_data.mainToastBanner.SubTitle}</em>
                    </div>
                </span>
            `}


                <button class="nc-banner-close"><span class="blind">그만보기</span></button>
            </div>
        ` );

        return this.el;
    }


    addEvents(_data: ncBannerOptions){
        const dataTypeToast = document.querySelector(".nc-banner[data-type=toast]") as HTMLElement;
        document.querySelector(".nc-banner[data-type=toast] .nc-banner-close")?.addEventListener('click', e =>{
            if(this.isCookieApply){
                setCookie('ncBanner'+_data.mainToastBanner.Cookie, "true", _data.mainToastBanner.CookieExpiredays, '.ncsoft.com'); // 쿠키 사용 (lineage2m nct)
                setCookie('ncBanner'+_data.mainToastBanner.Cookie, "true", _data.mainToastBanner.CookieExpiredays, '.ncsoft.jp'); // 쿠키 사용 (lineage2m ncj)
                setCookie('ncBanner'+_data.mainToastBanner.Cookie, "true", _data.mainToastBanner.CookieExpiredays, '.plaync.com');
            }
            removeClass( dataTypeToast , 'is-show');
        });
    }

}
export default MainToastLayer;
